import { Thankyou } from '../components/Thankyou/Thankyou';
import React from 'react';
import { Layout } from '../layout/Layout';
import ReactDOM from 'react-dom';

export default function Privatelabel() {
  return (
      <Layout>
        <Thankyou />
      </Layout>
  );
}



